<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-4 pt-md-7">
            <div class="row mb-2">
            </div>
        </base-header>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-lg-12 mb-3">
                    <card shadow>
                        <div slot="header" class="bg-white border-0">
                            <div class="row">
                                <div class="col-lg-6">
                                    <h3 class="mb-0">ติดตามสถานะพัสดุ</h3>
                                </div>
                                <div class="col-lg-6" v-if="tracking.switchSearch">
                                    <div class="row d-flex justify-content-end">
                                        <div class="col-lg-9">
                                            <b-input-group>
                                                <b-form-input type="search" placeholder="ค้นหา..." v-model="tracking.code"></b-form-input>
                                            </b-input-group>
                                        </div>
                                        <div class="col-lg-3">
                                            <b-button class="px-3" variant="primary" @click="getStatusTracking()">
                                                <i class="fas fa-circle-notch fa-spin" v-if="tracking.isLoadTracking"></i> ค้นหา
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body">
                                    <div class="row justify-content-md-center py-md-6" v-if="!tracking.switchSearch">
                                        <div class="col-lg-6">
                                            <SearchTracking 
                                                :tracking="tracking" 
                                                @onSearch="getStatusTracking()"
                                            />
                                        </div>
                                    </div>
                                    <template v-else>
                                        <OrderDetails :orderDetails="orderDetails" />
                                        
                                        <card shadow type="secondary">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <h4>ติดตามสถานะพัสดุ</h4>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <h5 class="text-muted" v-if="statesTracking.length < 1"> พัสดุอยู่ในขั้นตอน เตรียมจัดส่ง </h5>
                                                <div class="row">
                                                    <StatesTracking :statesTracking="statesTracking" />
                                                </div>
                                            </div>
                                        </card>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validatePop from "../plugins/validatePop.js"
import SearchTracking from '@/components/custom/tracking/SearchTracking'
import OrderDetails from '@/components/custom/tracking/OrderDetails'
import StatesTracking from '@/components/custom/tracking/StatesTracking'
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";


export default {
    name:"tracking",
    components:{
        SearchTracking,
        OrderDetails,
        StatesTracking
    },
    data(){
        return {
            tracking:{
                code:"",
                isLoadTracking: false,
                switchSearch: false,
            },
            orderDetails: {
                barcode: "",
                from: {},
                to: {},
                barcode: "",
                price: "",
                status: "",
                weight: "",
                width: "",
                length: "",
                height: "",
                cod_amount: "",
                cod_fee: "",
                insurance_price: "",
                insurance_remark: "",
                declared_value: "",
                created_at: ""
            },
            statesTracking: []
        }
    },
    methods: {
        getStatusTracking(){
            this.tracking.isLoadTracking = true

            this.$http
                .post(
                    this.$API_URL + "/status/tracking",
                    {
                        tracking_code : this.tracking.code
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    this.tracking.isLoadTracking = false

                    let checkError = validatePop( res )
                    if( !checkError.status ){
                        showErrorModal( checkError.msg )
                        return false
                    }

                    this.tracking.switchSearch = true
                    let resData = res.data.data;

                    Object.keys( resData.order_details[0] ).forEach(key => {
                        this.orderDetails[key] = resData.order_details[0][key]
                    });

                    if( resData.states_tracking ){
                        this.statesTracking = resData.states_tracking
                    }else{
                        this.statesTracking = [];
                    }
                    
                })
                .catch(error => {
                    this.tracking.isLoadTracking = false
                });
        }
    }
}
</script>